import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import BankAccountsList from "./pages/bankAccountList";
import AccountsActions from "./pages/accounts-actions";
import LendersAccountList from "./pages/lender-account-list";

export default function Lenders() {
    return (
        <Switch>
            <Route exact path={"/app/bank-accounts/"} component={AccountsActions}/>
            <Route exact path={"/app/bank-accounts/lending-partner/list"} component={LendersAccountList}/>
            <Route exact path={"/app/bank-accounts/company/list"} component={BankAccountsList}/>
            <Redirect to={"/app/bank-accounts/"} />
        </Switch>
    );
}


